import { useSWRConfig } from 'swr'
import { useTranslation } from '../../../../lib/i18n'
import BaseModal from '../../../common/modal/BaseModal'
import CLAvatar from '../../../common/CLAvatar'
import Button from '../../../common/Button'
import useGroup from '../../../../lib/useGroup'
import useUser from '../../../../lib/useUser'
import { useCacheKey } from '../../../context/CacheKey'

const WithdrawApplicationModal = ({
  groupSlug,
  isOpen,
  onRequestClose,
  invite,
}) => {
  const { t } = useTranslation()
  const { user } = useUser()
  const { group, removeUser } = useGroup(groupSlug, {
    invite,
  })
  const { mutate } = useSWRConfig()
  const cacheKey = useCacheKey()

  const handleWithdrawApplication = async () => {
    try {
      await removeUser(user?.id)
      mutate(
        invite
          ? `/api/group_invite/${invite}`
          : `/api/groups/${groupSlug}.json`,
        (oldData) => ({
          group: { ...oldData?.group, status: null, role: 'not member' },
        }),
        false
      )
      mutate(cacheKey.value)
      onRequestClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <BaseModal isOpen={isOpen} onRequestClose={onRequestClose} closeIcon>
      <div className="max-w-md mx-auto flex flex-col items-center justify-center text-center gap-4">
        <CLAvatar
          avatar={group?.avatar}
          name={group?.name}
          size={96}
          className="bg-gray-100"
        />
        <p className="text-lg font-bold">
          {t('forms.application.appliedToJoin', { groupName: group?.name })}
        </p>
        <p className="text-sm">{t('forms.application.applicationPending')}</p>
        <Button alert onClick={handleWithdrawApplication}>
          {t('groups.withdraw')}
        </Button>
      </div>
    </BaseModal>
  )
}

export default WithdrawApplicationModal
